import { render } from "./ActivityLog.vue?vue&type=template&id=2beca614&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"

import "./ActivityLog.vue?vue&type=style&index=0&id=2beca614&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beca614"]])

export default __exports__